module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        return $event.stopPropagation()
      }
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-wrapper"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading",
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": "loading",
      "size": "50px"
    }
  })], 1) : _vm._e()]) : _c('div', [_c('span', {
    staticClass: "lupa glyphicon glyphicon-search"
  }), _c('v-autocomplete', {
    attrs: {
      "id": _vm.id,
      "items": _vm.tags,
      "component-item": _vm.template,
      "input-attrs": _vm.attrs,
      "keep-open": _vm.show_tags,
      "auto-select-one-item": false
    },
    on: {
      "change": _vm.filterTags
    },
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  }), _c('hr', {
    staticClass: "full"
  }), _c('div', {
    staticClass: "tag-actions-buttons"
  }, [(_vm.tags.length == 0) ? _c('span', [_vm._v("Nenhuma tag foi encontrada")]) : _vm._e(), (_vm.show_button_apply) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.callExecuteChangeTags
    }
  }, [_vm._v("Aplicar")]) : _vm._e(), (_vm.autocomplete_text.length > 0) ? _c('a', {
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v(_vm._s(_vm.button_title_create_tag))]) : _vm._e(), (!_vm.current_user.isSeller()) ? _c('div', [(_vm.autocomplete_text.length == 0 && !_vm.show_button_apply) ? _c('a', {
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v("Criar Nova Tag")]) : _vm._e(), (_vm.autocomplete_text.length == 0 && !_vm.show_button_apply) ? _c('router-link', {
    attrs: {
      "to": '/configuracoes/tags'
    }
  }, [_vm._v("Editar tags")]) : _vm._e()], 1) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21847b42!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/autocomplete/tags.vue
// module id = 1041
// module chunks = 1